import axios from 'axios'
import api from '@/api'
import { TokenHelper } from "@/TokenHelper";

const defaultHtmlLandscape = `
<p style="text-align:left"><img src="/img/mel-logo-blue-cmyk.png" width="300"></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span class="ql-font-gilroy" style="font-size:60px">Certificate of Completion</span></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span class="ql-font-gilroy" style="font-size:24px">This is to certify that</span></p>
<p style="text-align:center"><strong class="ql-font-gilroy" style="font-size:36px;">{{ firstname }} {{ lastname }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span style="font-size:24px" class="ql-font-gilroy">Successfully completed the course entitled</span></p>
<p style="text-align:center"><strong style="font-size:36px;" class="ql-font-gilroy">{{ course.name }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span style="font-size:18px" class="ql-font-gilroy">Award date</span><span style="font-size:24px" class="ql-font-gilroy"> </span></p>
<p style="text-align:center"><strong style="font-size:30px;" class="ql-font-gilroy">{{ completion.date }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><img src="/img/mel-logo-blue-cmyk.png" class="ql-resize-style-right" width="300" style="margin:10px 0px 0px 0px"></p>
`

const defaultHtmlPortrait = `
<p style="text-align:left"><img src="/img/mel-logo-blue-cmyk.png" width="300"></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span class="ql-font-gilroy" style="font-size:48px">Certificate of Completion</span></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span class="ql-font-gilroy" style="font-size:30px">This is to certify that</span></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><strong class="ql-font-gilroy" style="font-size:36px;">{{ firstname }} {{ lastname }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span style="font-size:30px" class="ql-font-gilroy">Successfully completed the course entitled</span></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><strong style="font-size:36px;" class="ql-font-gilroy">{{ course.name }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><span style="font-size:24px" class="ql-font-gilroy">Award date</span><span style="font-size:24px" class="ql-font-gilroy"> </span></p>
<p style="text-align:center"><strong style="font-size:30px;" class="ql-font-gilroy">{{ completion.date }}</strong></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><br></p>
<p style="text-align:center"><img src="/img/mel-logo-blue-cmyk.png" class="ql-resize-style-right" width="300" style="margin:10px 0px 0px 0px"></p>
`


const data = {
  data: {
    id: '',
    tags: [],
    name: '',
    html: defaultHtmlLandscape,
    description: '<p></p>',
    frame: 'course_certificate',
    defaults: {},
    workspaceDefault: false,
    workspaceId: '',
    preview: '',
    settings: {
      background: '',
      backgroundOption: 'default',
      orientation: 'landscape',
      backgroundRotate: 0,
      paddingTop: 50,
      paddingRight: 50,
      paddingLeft: 50
    },
  },
  default: '',
  custom: {
    changed: false,
    defaultBackgroundLandscape: 'landscape-bg-cmyk.png',
    defaultBackgroundPortrait: 'portrait-bg-cmyk.png',
    contentModified: false
  },
  loading: {
    previewPendingCertificateIds: []
  }
}

const ebsCertificate = {
  state: JSON.parse(JSON.stringify(data)),
  getters: {
    getEbsDefaultHtml: (state) => {
      const orientation = state.data.settings?.orientation || 'landscape'
      return orientation === 'portrait' ? defaultHtmlPortrait : defaultHtmlLandscape
    },
    getEbsDefaultHtmlLandscape: () => {
      return defaultHtmlLandscape
    },
    getEbsDefaultHtmlPortrait: () => {
      return defaultHtmlPortrait
    },
    getEbsContentModified: state => {
      return state.custom.contentModified
    },
    getEbsCertificate: state => {
      return state.data
    },
    getEbsCertificateName: state => {
      return state.data.name
    },
    getEbsCertificateId: state => {
      return state.data.id
    },
    getEbsCertificateTags: state => {
      return state.data.tags
    },
    getEbsCertificateFrame: state => {
      return state.data.frame
    },
    getEbsCertificateHtml: state => {
      return state.data.html
    },
    getEbsCertificateSettingsOrientation: state => {
      return state.data.settings?.orientation || 'portrait'
    },
    getEbsCertificateBackground: state => {
      return state.data.settings?.background
    },
    getEbsCertificateDefaultBackgroundFile: state => {
      const orientation = state.data.settings?.orientation || 'landscape'
      return orientation === 'portrait' 
        ? state.custom?.defaultBackgroundPortrait
        : state.custom?.defaultBackgroundLandscape
    },
    getEbsCertificatePaddingTop: state => {
      return state.data.settings?.paddingTop !== undefined ? state.data.settings?.paddingTop : 50
    },
    getEbsCertificatePaddingRight: state => {
      return state.data.settings?.paddingRight !== undefined ? state.data.settings?.paddingRight : 50
    },
    getEbsCertificatePaddingLeft: state => {
      return state.data.settings?.paddingLeft !== undefined ? state.data.settings?.paddingLeft : 50
    },
    getEbsCertificatePreviewPending: state => certificateId => {
      return state.loading.previewPendingCertificateIds.includes(certificateId)
    },
    getEbsCertificateBackgroundRotate: state => {
      return state.data.settings?.backgroundRotate || 0
    },
    getEbsCertificateBackgroundOption: state => {
      return state.data.settings?.backgroundOption !== undefined ? state.data.settings?.backgroundOption : 'default'
    },
    getEbsCertificatePreview: state => {
      return state.data.preview
    },
    getEbsCertificateWorkspaceDefault: state => {
      return state.data.workspaceDefault
    },
    getEbsCertificateWorkspaceId: state => {
      return state.data.workspaceId
    },
    getEbsCertificateDescription: state => {
      return state.data.description
    },
    getEbsCertificateCustomChanged: state => {
      return (
          state.data !== '' &&
          state.default !== '' &&
          (
              state.data.workspaceDefault !== state.default.workspaceDefault ||
              state.data.name !== state.default.name ||
              state.data.html !== state.default.html ||
              state.data.settings.orientation !== state.default.settings.orientation ||
              state.data.settings.background !== state.default.settings.background ||
              state.data.settings.backgroundRotate !== state.default.settings.backgroundRotate ||
              state.data.settings.backgroundOption !== state.default.settings.backgroundOption ||
              state.data.settings.paddingTop !== state.default.settings.paddingTop ||
              state.data.settings.paddingRight !== state.default.settings.paddingRight ||
              state.data.settings.paddingLeft !== state.default.settings.paddingLeft
          )
      )
    }
  },
  mutations: {
    EBS_CERTIFICATE_GET (state, payload) {
      let payloadData = JSON.parse(JSON.stringify(payload))
      if (!payloadData.settings) {
        payloadData.settings = data.data.settings
      } else {
        payloadData.settings.orientation = payloadData.settings.orientation || data.data.settings.orientation
        payloadData.settings.background = payloadData.settings.background || data.data.settings.background
        payloadData.settings.backgroundRotate = payloadData.settings.backgroundRotate || data.data.settings.backgroundRotate
        payloadData.settings.backgroundOption = payloadData.settings.backgroundOption !== undefined ? payloadData.settings.backgroundOption : (payloadData.settings.background ? 'selected' : data.data.settings.backgroundOption)
        payloadData.settings.paddingTop = payloadData.settings.paddingTop !== undefined ? payloadData.settings.paddingTop : data.data.settings.paddingTop
        payloadData.settings.paddingRight = payloadData.settings.paddingRight !== undefined ? payloadData.settings.paddingRight : data.data.settings.paddingRight
        payloadData.settings.paddingLeft = payloadData.settings.paddingLeft !== undefined ? payloadData.settings.paddingLeft : data.data.settings.paddingLeft
      }

      state.data = JSON.parse(JSON.stringify(payloadData))
      state.default = JSON.parse(JSON.stringify(payloadData))
      state.custom.contentModified = false
    },
    EBS_CERTIFICATE_CLEAR (state) {
      state.data = JSON.parse(JSON.stringify(data.data))
      state.default = JSON.parse(JSON.stringify(data.data))
      state.custom = JSON.parse(JSON.stringify(data.custom))
      state.loading = JSON.parse(JSON.stringify(data.loading))
      state.custom.contentModified = false
    },
    EBS_CERTIFICATE_RESET (state) {
      state.data = JSON.parse(JSON.stringify(state.default))
    },
    EBS_CERTIFICATE_SET_NAME (state, payload) {
      state.data.name = payload
    },
    EBS_CERTIFICATE_SET_TAGS (state, payload) {
      state.data.tags = payload
    },
    EBS_CERTIFICATE_SET_FRAME (state, payload) {
      state.data.frame = payload
    },
    EBS_CERTIFICATE_SET_HTML (state, payload) {
      state.data.html = payload
    },
    EBS_CERTIFICATE_SET_CONTENT_MODIFIED (state, payload) {
      state.custom.contentModified = payload
    },
    EBS_CERTIFICATE_SET_SETTINGS_ORIENTATION (state, payload) {
      const oldOrientation = state.data.settings.orientation
      state.data.settings.orientation = payload
      
      if (oldOrientation !== payload && !state.custom.contentModified) {
        const newDefaultHtml = payload === 'portrait' ? defaultHtmlPortrait : defaultHtmlLandscape
        state.data.html = newDefaultHtml
      }
    },
    EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND (state, payload) {
      state.data.settings.background = payload
    },
    EBS_CERTIFICATE_SET_SETTINGS_PADDING_TOP (state, payload) {
      state.data.settings.paddingTop = payload
    },
    EBS_CERTIFICATE_SET_SETTINGS_PADDING_RIGHT (state, payload) {
      state.data.settings.paddingRight = payload
    },
    EBS_CERTIFICATE_SET_SETTINGS_PADDING_LEFT (state, payload) {
      state.data.settings.paddingLeft = payload
    },
    EBS_CERTIFICATE_SET_PREVIEW_PENDING (state, { certificateId, loading }) {
      if (loading) {
        if (!state.loading.previewPendingCertificateIds.includes(certificateId)) {
          state.loading.previewPendingCertificateIds.push(certificateId)
        }
      } else {
        state.loading.previewPendingCertificateIds = state.loading.previewPendingCertificateIds.filter(id => id !== certificateId)
      }
    },
    EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND_ROTATE (state, payload) {
      state.data.settings.backgroundRotate = payload
    },
    EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND_OPTION (state, payload) {
      state.data.settings.backgroundOption = payload
    },
    EBS_CERTIFICATE_SET_PREVIEW (state, payload) {
      state.data.preview = payload
    },
    EBS_CERTIFICATE_SET_WORKSPACEDEFAULT (state, payload) {
      state.data.workspaceDefault = payload
    },
    EBS_CERTIFICATE_SET_WORKSPACEID (state, payload) {
      state.data.workspaceId = payload
    },
    EBS_CERTIFICATE_SET_DESCRIPTION (state, payload) {
      state.data.description = payload
    },
  },
  actions: {
    ebsCertificateGet ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const certificateId = data.certificateId
        const workspaceId = data.workspaceId
        const token = data.token || TokenHelper.getToken('secondStageToken')

        axios({
            method: 'get',
            url: `${ api.learningactivities }/certificate/content/${ certificateId }${ workspaceId ? `?workspaceId=` + workspaceId : '' }`,
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            commit('EBS_CERTIFICATE_GET', response.data)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    ebsCertificateCreate ({ state, getters, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let stateData = JSON.parse(JSON.stringify(state.data))
        stateData.name = stateData.name || getters.getEbsCourseName
        if (data && data.workspaceDefault !== undefined) {
          stateData.workspaceDefault = data.workspaceDefault
        }
        if (data && data.workspaceId !== undefined) {
          stateData.workspaceId = data.workspaceId
        }
        axios({
          method: 'post',
          url: `${ api.learningactivities }/certificate/content`,
          data: stateData
        }).then(response => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate create',
            message: `Certificate has been successfully created.`,
            status: 'success'
          })
          resolve(response)
        }).catch(error => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate create',
            message: `Certificate hasn't been created.`,
            status: 'error'
          })
          reject(error)
        })
      })
    },
    ebsCertificateUpdate ({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        let stateData = JSON.parse(JSON.stringify(state.data))

        axios({
          method: 'patch',
          url: `${ api.learningactivities }/certificate/content`,
          data: stateData
        }).then(response => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate update',
            message: `Certificate has been successfully updated.`,
            status: 'success'
          })
          resolve(response)
        }).catch(error => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate update',
            message: `Certificate hasn't been updated.`,
            status: 'error'
          })
          reject(error)
        })
      })
    },
    ebsCertificateDuplicate ({ state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let certificateData = data || JSON.parse(JSON.stringify(state.data))
        certificateData.id = undefined
        certificateData.owner = undefined
        certificateData.workspaceDefault = false
        certificateData.name = certificateData.name + ' (copy)'

        axios({
          method: 'post',
          url: `${ api.learningactivities }/certificate/content`,
          data: certificateData
        }).then(response => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate duplicate',
            message: `Certificate has been successfully duplicated.`,
            status: 'success'
          })
          resolve(response)
        }).catch(error => {
          dispatch('defaultNotificationToastsAdd', {
            title: 'Certificate duplicate',
            message: `Certificate hasn't been duplicated.`,
            status: 'error'
          })
          reject(error)
        })
      })
    },
    ebsCertificateDownload (ctx, payload) {
      const certificateId = payload.certificateId
      const workspaceId = payload.workspaceId
      const token = TokenHelper.getToken('secondStageToken') || ctx.rootState.route.query.token

      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          url: `${api.learningactivities}/v2/certificate/template/${certificateId}/${workspaceId}?token=${token}`,
          responseType: 'arraybuffer'
        }).then((response) => {
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${ payload.name } certificate.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), `${ payload.name } certificate.pdf`)
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificateDownloadByUrl (ctx, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          url: payload.url,
          responseType: 'arraybuffer'
        }).then((response) => {
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${ payload.name } certificate.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), `${ payload.name } certificate.pdf`)
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificateRemove (ctx, id) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'delete',
          url: `${ api.learningactivities }/certificate/content`,
          data: {
            id
          }
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificatePreviewByContentId (ctx, data) {
      const id = data.id
      const name = data.name
      const token = data.token
      console.log('%c token', 'color: orange', token)

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: `https://learning-activities.api.melearning.co.uk/api/certificates/preview-by-content${ id ? `/` + id : '' }`,
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(response => {
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${ name }-sample.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), `${ name }-sample.pdf`)
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificatePreviewByCertificateId ({ commit }, payload) {
      const certificateId = payload.certificateId
      const workspaceId = payload.workspaceId
      const token = TokenHelper.getToken('secondStageToken') || payload.token
      const name = payload.name

      commit('EBS_CERTIFICATE_SET_PREVIEW_PENDING', { certificateId, loading: true })

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: `${ api.learningactivities }/v2/certificate/template${certificateId ? `/${certificateId}` : ''}${workspaceId ? `/${workspaceId}` : ''}${token ? `?token=${token}` : ''}`,
          responseType: 'arraybuffer'
        }).then(response => {
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${ name }-sample.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), `${ name }-sample.pdf`)
          }
          resolve()
        }).catch(error => {
          reject(error)
        }).finally(() => {
          commit('EBS_CERTIFICATE_SET_PREVIEW_PENDING', { certificateId, loading: false })
        })
      })
    },
    ebsCertificateSetName ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_NAME', data)
    },
    ebsCertificateSetHtml ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_HTML', data)
    },
    ebsCertificateSetContentModified ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_CONTENT_MODIFIED', data)
    },
    ebsCertificateSetSettingsOrientation ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_ORIENTATION', data)
    },
    ebsCertificateSetBackground ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND', data)
    },
    ebsCertificateSetPaddingTop ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_PADDING_TOP', data)
    },
    ebsCertificateSetPaddingRight ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_PADDING_RIGHT', data)
    },
    ebsCertificateSetPaddingLeft ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_PADDING_LEFT', data)
    },
    ebsCertificateSetBackgroundRotate ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND_ROTATE', data)
    },
    ebsCertificateSetBackgroundOption ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_SETTINGS_BACKGROUND_OPTION', data)
    },
    ebsCertificateCheckWorkspaceDefault ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_WORKSPACEDEFAULT', data)
    },
    ebsCertificateSetWorkspaceDefault (ctx, data) {
      return new Promise((resolve, reject) => {
        const workspaceId = data.workspaceId
        const certificateContentId = data.certificateContentId

        axios({
          method: 'post',
          url: `${ api.learningactivities }/certificate/default/${ workspaceId }/${ certificateContentId }`
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificateUnsetWorkspaceDefault (ctx, workspaceId) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${ api.learningactivities }/certificate/remove-default/${ workspaceId }`
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsCertificateSetWorkspaceId ({ commit }, data) {
      commit('EBS_CERTIFICATE_SET_WORKSPACEID', data)
    },
    ebsCertificateReset ({ commit }, data) {
      commit('EBS_CERTIFICATE_RESET', data)
    },
    ebsCertificateClear ({ commit }, data) {
      commit('EBS_CERTIFICATE_CLEAR', data)
    }
  }
}

export default ebsCertificate
